import React, { useState, useEffect, useRef } from "react";

import WheelSlice from "./WheelSlice";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { wheelNumbers } from "../../../utils/NumberDetails";
import { updatePickingHistory } from "../../../store/picks/userPick-slice";
import { setCarouselNumberForSpin } from "../../../store/picks/carousel-slice";
import store from "../../../store/store";
import {
  setDrawTab,
  setShouldSpinWheel,
  setSpinAgainTimeout,
} from "../../../store/picks/tabs-slice";
import ModalMessage from "../../Common/ModalMessage/ModalMessage";
import { GameTypeEnum } from "../../../enums";

interface Props {
  winningNumber: number;
}

const WheelSlices: React.FC<Props> = ({ winningNumber }) => {
  const lastWinningNumber = useAppSelector(
    (state) => state.wheel.lastWinningNumber
  );
  const numbersToAdd = [];
  const [lastHighlightedIndex, setLastHighlightedIndex] = useState(
    wheelNumbers.indexOf(lastWinningNumber)
  );
  const drawStarted = useAppSelector((state) => state.tab.drawStarted);
  const shouldSpinWheel = useAppSelector((state) => state.tab.shouldSpinWheel);
  const pulsatingSpinnerTimeout = useAppSelector(
    (state) => state.config.pulsatingSpinnerTimeout
  );
  const isInitialHighlight = useRef(true);
  const pickedStakes = useAppSelector((state) => state.picks.pickedStakes);
  const [infoModalMessage, setInfoModalMessage] = useState("");
  const dispatch = useAppDispatch();

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    const timeoutHandler = (): void => {
      dispatch(setCarouselNumberForSpin());
      dispatch(updatePickingHistory(pickedStakes.map((bet) => bet.value)));

      if (store.getState().config.winAmmount <= 0) {
        if (store.getState().config.gameType === GameTypeEnum.ONLINE) {
          setInfoModalMessage("message.betterLuck");
          dispatch(setDrawTab(false));
        } else {
          dispatch(setShouldSpinWheel(false));
        }
      }
    };

    if (drawStarted || shouldSpinWheel) {
      setTimeout(() => {
        let counter = 0;
        let speed = 1;
        let changedCounter = 0;
        let isInitial = true;
        let totalCounter = 0;
        setLastHighlightedIndex(wheelNumbers.indexOf(lastWinningNumber));
        const indexOfWinningNumber = wheelNumbers.indexOf(winningNumber);
        const indexOfLastWinningNumber = wheelNumbers.indexOf(
          lastWinningNumber
        );
        const difBetweenIndexes =
          indexOfWinningNumber - indexOfLastWinningNumber > 0
            ? indexOfWinningNumber - indexOfLastWinningNumber
            : 13 + (indexOfWinningNumber - indexOfLastWinningNumber);

        const interval = setInterval(() => {
          if (store.getState().tab.isBrowserTabOrWindowInterrupt) {
            clearInterval(interval);
            setTimeout(() => {
              timeoutHandler();
            }, 1000);
            setLastHighlightedIndex(indexOfWinningNumber);
          }

          if (counter !== 0 && changedCounter % 15 === 0) {
            speed += 1;
            counter = 0;
            changedCounter = 0;
            isInitial = true;
          }

          if (totalCounter === 65 + difBetweenIndexes) {
            clearInterval(interval);
            setTimeout(() => {
              timeoutHandler();
            }, 2000);
          }

          if (
            !store.getState().tab.isBrowserTabOrWindowInterrupt &&
            counter % speed === 0
          ) {
            if (!isInitial) {
              setLastHighlightedIndex((prevState) => prevState + 1);
              totalCounter += 1;
            }

            isInitial = false;
            changedCounter += 1;
          }

          counter += 1;
        }, 25);

        return () => clearInterval(interval);
      }, pulsatingSpinnerTimeout);
    }
  }, [
    pickedStakes,
    dispatch,
    drawStarted,
    shouldSpinWheel,
    lastWinningNumber,
    pulsatingSpinnerTimeout,
    winningNumber,
  ]);

  for (let i = 0; i < wheelNumbers.length; i += 1) {
    let lightClass = "";
    if (lastHighlightedIndex % wheelNumbers.length === i) {
      lightClass = "inlight";
      if (isInitialHighlight.current) {
        isInitialHighlight.current = false;
      } else {
        lightClass += " light";
      }
    }

    numbersToAdd.push(
      <WheelSlice
        key={`wheelSlice_${i}`}
        classStatus={lightClass}
        value={wheelNumbers[i]}
      />
    );
  }

  return (
    <>
      <ul className="wheel_slices">{numbersToAdd}</ul>
      {infoModalMessage !== "" && (
        <ModalMessage
          className="lost fade_modal"
          message={infoModalMessage}
          onApprove={() => {
            setInfoModalMessage("");
            dispatch(setSpinAgainTimeout(3));
          }}
        />
      )}
    </>
  );
};

export default WheelSlices;
